import React from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
  id: string;
  htmlFor?: string;
}

export default function Wrapper({ className, children, id, htmlFor }: Props) {
  if (htmlFor) {
    return (
      <label className={className} id={id} htmlFor={htmlFor}>
        {children}
      </label>
    );
  }
  return (
    <div className={className} id={id}>
      {children}
    </div>
  );
}
